import * as React from 'react';
import * as Redux from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { Main } from '../reducers';
import { WebformContainer } from './webform-container';
import { autobind } from 'core-decorators';
import { IExternalIncidentParams } from '@logicmanager/common';
import * as BUILD from '../../config/config';
import { IState } from '../interfaces';
/**
 * App component holds application state object
 */
export class App extends React.Component<IAppProps, IAppState> {
  constructor(props: any) {
    super(props);
    this.state = {
      store: BUILD.ENV !== 'production'
        ? Redux.createStore(Main, composeWithDevTools(Redux.applyMiddleware()))
        : Redux.createStore(Main)
    };
  }

  @autobind
  public parseQueryString(queryString: string): IExternalIncidentParams {
    if (!queryString) {
      return null;
    }
    const paramArray: string[] = queryString.replace('?', '').split('&');
    const params: any = {};
    for (let i: number = 0; i < paramArray.length; i++) {
      const key: string = paramArray[i].split('=')[0];
      const value: string = paramArray[i].split('=')[1];
      params[key] = value;
    }
    return {
      test: params.t,
      plan: params.p,
      key: params.k
    };
}

  public render(): JSX.Element {
    return (
      <Provider store={this.state.store}>
        <WebformContainer
          params={this.parseQueryString(this.props.location.search)}
          history={this.props.history}
          internal={this.props.internal}
          testId={this.props.testId}
          onCloseModal={this.props.onCloseModal}
          modal={this.props.modal}
          entityId={this.props.entityId}
          entityTypeId={this.props.entityTypeId}
        />
      </Provider>
    );
  }
}

export interface IAppProps {
  readonly history: any;
  readonly location?: any;
  readonly internal?: boolean;
  readonly testId?: number;
  readonly entityId?: string;
  readonly entityTypeId?: string;
  onCloseModal?(submit?: boolean): void;
}

export interface IAppState {
  /** Instance of Redux Store */
  readonly store: Redux.Store<IState>;
}
